module.exports = new __parcel__URL__("trumpet_select.7aa73c13.mp3").toString();